import doctorRoutes from './doctor-routes'                  // 门诊医生
import nurseRoutes from './nurse-routes'                    // 门诊护士
import tollRoutes from './toll-routes'                      // 收费处
import drugRoutes from './drug-routes.js'                   // 药店（药房）
import financeRoutes from './finance-routes'                // 财务科
import techRoutes from './tech-routes'                      // 医技
import infoManagementRoutes from './info-management-routes' // 信息科
import dictionaryRoutes from './dictionary-routes'          // 字典
import systemRoutes from './system-routes'                  // 系统
import liveTollRoutes from './live-toll-routes'                  // 住院收费处
import liveNurseRoutes from './live-nurse-routes'                  // 住院收费处
import operatingTheaterRoutes from './operating-theater'                  // 手术室
import dashboard from './dashboard-routers'
import inpatientDoctorRouters from './inpatient-doctor-routers'                  // 住院医生
import errorRoutes from './error-routes'                     // 错误
import patientRoutes from './patient-routes'                     // 随访
import emrRoutes from './emr-routers'                     // 随访
import ePrescribing from './e-prescribing'

// 挂载路由集合
let baseRoutes = [
  {
    path: '/',
    component: resolve => require(['../views/login.vue'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    title: '系统登录',
    component: resolve => require(['../views/login.vue'], resolve)
  },
  {
    path: '/default',
    name: 'default',
    title: '医院信息管理云平台',
    component: resolve => require(['../views/default.vue'], resolve),
    children: [
      {
        path: 'current',
        name: 'current',
        meta: {
          title: '首页',
          requiresAuth: true,
          nav: false
        },
        component: resolve => require(['../views/page/page-current.vue'], resolve)
      },
      {
        path: 'workplace',
        name: 'workplace',
        meta: {
          title: '工作站',
          requiresAuth: true,
          nav: false
        },
        component: resolve => require(['../views/page/page-workplace.vue'], resolve)
      },
      {
        path: 'chat',
        name: 'chat',
        meta: {
          title: '消息',
          requiresAuth: true,
          nav: false
        },
        component: resolve => require(['../views/page/page-chat.vue'], resolve)
      },
      {
        path: 'contact',
        name: 'contact',
        meta: {
          title: '联系人',
          requiresAuth: true,
          nav: false
        },
        component: resolve => require(['../views/page/page-contact.vue'], resolve)
      },
      {
        path: 'mine',
        name: 'mine',
        meta: {
          title: '我的',
          requiresAuth: true,
          nav: false
        },
        component: resolve => require(['../views/page/page-mine.vue'], resolve)
      },
      {
        path: 'bi/:code',
        name: 'bi',
        meta: {
          title: '',
          requiresAuth: true,
          nav: {
            title: '工作站',
            path: '/default/workplace',
            children: null
          }
        },
        component: resolve => require(['../views/page/bi.vue'], resolve)
      }
    ].concat(liveTollRoutes, liveNurseRoutes)
  }
]

baseRoutes[2].children = baseRoutes[2].children.concat(doctorRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(nurseRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(tollRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(drugRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(financeRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(techRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(infoManagementRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(dictionaryRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(systemRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(errorRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(inpatientDoctorRouters)
baseRoutes[2].children = baseRoutes[2].children.concat(operatingTheaterRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(dashboard)
baseRoutes[2].children = baseRoutes[2].children.concat(patientRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(emrRoutes)
baseRoutes[2].children = baseRoutes[2].children.concat(ePrescribing)

// 导出路由集合
export default baseRoutes
